module.exports = __webpack_public_path__ + "img/icon_ai_more@3x.453a8e4a.png";